import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tiktok-brands",
  "use": "tiktok-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tiktok-brands\"><path d=\"M22.5 9.842a9.85 9.85 0 01-5.756-1.84v8.38a7.622 7.622 0 11-6.576-7.553v4.215a3.5 3.5 0 102.45 3.337V0h4.126c-.003.348.026.696.087 1.04a5.73 5.73 0 002.527 3.76 5.694 5.694 0 003.142.945v4.097z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol